import { Component, inject, input } from '@angular/core';
import { I18nModule } from '@spartacus/core';
import { CommonUtils } from '../../shared/utils/common.utils';
import { RouterLink } from '@angular/router';
import { OrderHistoryService } from '../order-history.service';
import { LoaderComponent } from '../../account-overview/account-overview/loader/loader.component';
import { US_DATE_FORMAT } from '../../shared/config/app.config';

@Component({
  selector: 'sanofi-orders-table',
  standalone: true,
  imports: [
    I18nModule,
    RouterLink,
    LoaderComponent
  ],
  templateUrl: './orders-table.component.html'
})
export class OrdersTableComponent {
  private readonly service = inject(OrderHistoryService);

  orders = input.required<any[]>();
  dateFormat = input<string>(US_DATE_FORMAT);
  isCompactView = input<boolean>(false);
  isLoading = input<boolean>(false);

  protected readonly CommonUtils = CommonUtils;

  sortColumn(event: any, fieldName: string, dataList: any[], type: string): any {
    CommonUtils.onSortClick(event, fieldName, dataList, type); // Column Sorting
  }

  getPONumber(purchaseOrderNumber: string): string {
    if (purchaseOrderNumber) {
      const poNumber = '';
      const searchString = 'WWW:';
      const regex = new RegExp(searchString, 'i');
      if (regex.test(purchaseOrderNumber)) {
        return poNumber;
      } else {
        return purchaseOrderNumber;
      }
    }
  }

  generateInvoicePDF(invoiceNo: string): void {
    this.service.downloadPdf(invoiceNo);
  }

  navigateToTracking(data: string, url: string, event: any): void {
    const a = url.split('<TRACKN>');
    event.target.rel = a[0] + data;
  }
}
